<template>
	<div class="msg-analysis-rp" v-if="!isError">
		<div class="msg-analysis-rp-info">
			<span class="msg-analysis-rp-img"></span>
			<span class="msg-analysis-rp-text">{{message.receivertitle}}</span>
		</div>
		<div class="msg-analysis-rp-footer">
			<span>微信红包</span>
		</div>
	</div>
	<div class="msg-analysis-rp-error" v-else>
		红包消息格式错误，请在手机端查看！
	</div>
</template>

<script>
	import AppConfig from '../../../config/AppConfig.js'
	export default{
		name: 'MsgAnalysisRed_package',
		components:{
			
		},
		props:{
			msg:{
				  type:Object,
				  default:function(){
					  return {}
				  }
			}
		},
		data(){
			return {
				message: '',
				isError: false
			}
		},
		methods:{
			format(){
				try {
					this.message = JSON.parse(this.msg.content);
				}catch (e) {
					this.isError = true
				}
			}
		},
		
		created() {
			this.format()
		}
	}
</script>

<style>
	.msg-analysis-rp-error{
		background-color: #f19595;
		padding: 8px;
		font-size: 12px;
		border-radius: 2px;
	}
	.msg-analysis-rp{
	    background: #ffffff;
	    position: relative;
	    cursor: pointer;
	    border-radius: 4px;
	    min-width: 200px;
		border: 1px solid #e8e8e8;
	}
	.msg-analysis-rp .msg-analysis-rp-info{
	    background-image: -moz-linear-gradient(to left,#f9a243,#f57e52);
	    background-image: -o-linear-gradient(to left,#f9a243,#f57e52);
	    background-image: -webkit-linear-gradient(to left,#f9a243,#f57e52);
	    background-image: linear-gradient(to left,#f9a243,#f57e52);
	    height: 60px;
	    line-height: 60px;
	    display: flex;
	    flex-direction:row;
	    flex-wrap: nowrap;
	    justify-content: left;
	    align-items:center;
	    align-content: flex-start;
	    padding: 0 5px;
	    border-radius: 4px 4px 0 0;
	}
	.msg-analysis-rp-info span{
	    display: block;
	    min-width: 30px;
	    max-width: 200px;
	    max-height: 60px;
	    overflow: hidden;
	    padding: 0 5px;
	    color: #ffffff;
	}
	.msg-analysis-rp-info .msg-analysis-rp-img{
	    width: 32px;
	    height: 32px;
	    padding: 0;
	    margin-right:5px;
	    margin-left:5px;
	    overflow: hidden;
	    background: url("/img/red_package.png") no-repeat;
	    background-size:32px 32px;
	}
	.msg-analysis-rp .msg-analysis-rp-footer{
	    height: 20px;
	    line-height: 20px;
	    font-size: 12px;
	    color: #666666;
	    text-indent: 8px;
	}
</style>
